import './SuggestionDetails.css';
export var suggestionDetails = '_tn2lgm0-3-12-1';
export var suggestionDetailsText = '_tn2lgm1-3-12-1';